import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tekrevol_dark_bg tabing_section web_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Technologies TekRevol Uses for Mobile App Development in Miami
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              As a leading mobile app development company in miami, we employ a
              diverse set of powerful technologies to cater to your unique
              requirements. In Android development, we utilize Java, Kotlin,
              Fastlane, Gradle, Coroutines, Dagger2, and JetPack. On the iOS
              side, we leverage SwiftLint, Objective-C, RxSwift, CircleCI,
              Swift, SwiftUI, and CocoaPods. For the creation of hybrid apps,
              our toolkit includes TypeScript, React Native, Javascript,
              Flutter, and Native Script. When it comes to backend development,
              we harness the capabilities of Node.js, Ruby on Rails (RoR),
              Python, and Firebase.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Android">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/android_icons/java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/android_icons/gradle.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Gradle</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/android_icons/kotlin.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kotlin</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/android_icons/fastlane.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Fastlane</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/android_icons/coroutines.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Coroutines</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="iOS">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/circleci.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CircleCI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/cocoapods.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CocoaPods</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/objective-C.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Objective-C</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/rxswift.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Rxswift</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/swiftlint.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Swiftlint</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/swiftui.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Swiftui</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Backend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/backend/firebase.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/backend/nodeJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>NodeJs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/backend/python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/backend/ruby_on_rail.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Ruby on Rails</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Cross Platform">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/cross_platform/flutter.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Flutter</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/cross_platform/javascript.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Javascript</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/cross_platform/native_script.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Nativescript</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/cross_platform/react_native.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>React native</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/cross_platform/type_script.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Typescript</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
